<!-- Adapted from Swing SeeAll.vue, f0b87657c6450dc12d2dfd286b75f501410dcabd, MIT. -->
<template><span class="see-all"><router-link :to="route">{{ text || '查看全部' }}</router-link></span></template>
<script>
export default { name: 'SwingSeeAll', props: { route: { type: String, required: true }, text: { type: String, default: '' } } };
</script>
<style scoped>
.see-all { font-size:12px; font-weight:400; color:var(--salt-subtext,var(--color-secondary)); white-space:nowrap; }
.see-all a:hover { text-decoration:underline; }
.see-all a:focus-visible { outline:2px solid var(--salt-accent,var(--color-primary)); outline-offset:3px; }
</style>
